module.exports = __webpack_public_path__ + "img/BG.7fb8095b.svg";